<template>
  <div>
    <appbar @toggle="toggleDrawer" :profile="profile" />
    <appdrawer
      v-model="drawerOpen"
      :mini.sync="mini"
      :profile="profile"
    ></appdrawer>
    <v-sheet
      style="height: 100vh;"
      color="transparent"
      id="scrolling-techniques-7"
      class="overflow-y-auto bg-canvas"
    >
      <v-main style="height: 100vh;"><router-view /></v-main>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Drawer from "./Drawer";
import Header from "./Header";
import { getAuthToken } from "@/utils/helpers";
export default {
  name: "Master",
  components: {
    appbar: Header,
    appdrawer: Drawer
  },
  computed: {
    ...mapGetters({
      profile: "auth/getUserDetails"
    })
  },
  data() {
    return {
      // null lets Vuetify pick the initial state: open on desktop,
      // closed (overlay) below the drawer's mobile breakpoint.
      drawerOpen: null,
      mini: false
    };
  },

  methods: {
    toggleDrawer() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawerOpen = !this.drawerOpen;
      } else {
        this.mini = !this.mini;
      }
    }
  },
  created() {
    if (getAuthToken()) {
      this.$store.dispatch("auth/me");
    }
  }
};
</script>
